/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { HIDE_ERROR } from 'actions/error';

import {
  ACCEPT_USER_FAILURE,
  REJECT_USER_FAILURE,
  ADD_ROLE_FAILURE,
} from 'actions/admin';
import { BOOTSTRAP_FAILURE } from 'actions/app';
import { G_AUTH_FAILURE, AUTH_FAILURE } from 'actions/auth';
import {
  REGISTER_COMPANY_FAILURE,
  UPDATE_COMPANY_FAILURE,
  GET_COMPANY_FAILURE,
} from 'actions/company';
import { UPLOAD_IMAGE_FAILURE } from 'actions/cloudinary';
import {
  UPDATE_PROFILE_FAILURE,
  REQUEST_CODE_FAILURE,
  VERIFY_CODE_FAILURE,
  RESET_CODE_FAILURE,
  ADD_PICTURE_FAILURE,
  DELETE_PROFILE_FAILURE,
  GET_PROFILE_FAILURE,
  RESET_PASSWORD_FAILURE,
  UPDATE_PASSWORD_FAILURE,
  REORDER_PICTURES_FAILURE,
} from 'actions/user';
import {
  CREATE_JOB_FAILURE,
  UPDATE_JOB_FAILURE,
  GET_USER_JOBS_FAILURE,
  GET_JOB_FAILURE,
  DELETE_JOB_FAILURE,
  PUBLISH_JOB_FAILURE,
  ADD_POSITION_FAILURE,
  UPDATE_POSITION_FAILURE,
  DELETE_POSITION_FAILURE,
  PUBLISH_POSITION_FAILURE,
  REQUEST_TALENT_FAILURE,
  APPLY_JOB_FAILURE,
  SAVE_TALENT_FAILURE,
  UNSAVE_TALENT_FAILURE,
  SEND_REQUESTS_FAILURE,
} from 'actions/job';
import {
  INVITE_FRIEND_FAILURE,
  INVITE_COLLEAGUE_FAILURE,
} from 'actions/invite';
import {
  GET_MESSAGES_FAILURE,
  GET_MESSAGE_FAILURE,
  SEND_MESSAGE_FAILURE,
  DISCUSSION_ACTION_FAILURE,
} from 'actions/inbox';
import { SEARCH_TALENTS_FAILURE } from 'actions/search';
import {
  REGISTER_FREELANCE_FAILURE,
  REGISTER_FREELANCE_COMPANY_FAILURE,
  UPDATE_FREELANCE_COMPANY_FAILURE,
} from 'actions/paymentMethod';
import {
  GET_SHORTLIST_FAILURE,
  CREATE_SHORTLIST_FAILURE,
  ADD_TALENT_SHORTLIST_FAILURE,
} from 'actions/shortlist';

const initialState = {
  show: false,
  message: '',
};

/**
 * This is the company reducer. It listens for actions and updates the company object.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export default function(state = initialState, { type, payload }) {
  switch (type) {
    case BOOTSTRAP_FAILURE:
    case AUTH_FAILURE:
    case GET_COMPANY_FAILURE:
    case REGISTER_COMPANY_FAILURE:
    case UPDATE_COMPANY_FAILURE:
    case UPDATE_PROFILE_FAILURE:
    case REQUEST_CODE_FAILURE:
    case VERIFY_CODE_FAILURE:
    case RESET_CODE_FAILURE:
    case ADD_PICTURE_FAILURE:
    case DELETE_PROFILE_FAILURE:
    case GET_PROFILE_FAILURE:
    case CREATE_JOB_FAILURE:
    case UPDATE_JOB_FAILURE:
    case GET_JOB_FAILURE:
    case GET_USER_JOBS_FAILURE:
    case DELETE_JOB_FAILURE:
    case PUBLISH_JOB_FAILURE:
    case APPLY_JOB_FAILURE:
    case ADD_POSITION_FAILURE:
    case UPDATE_POSITION_FAILURE:
    case DELETE_POSITION_FAILURE:
    case REQUEST_TALENT_FAILURE:
    case INVITE_FRIEND_FAILURE:
    case INVITE_COLLEAGUE_FAILURE:
    case SEARCH_TALENTS_FAILURE:
    case GET_MESSAGES_FAILURE:
    case GET_MESSAGE_FAILURE:
    case SEND_MESSAGE_FAILURE:
    case DISCUSSION_ACTION_FAILURE:
    case REGISTER_FREELANCE_COMPANY_FAILURE:
    case UPDATE_FREELANCE_COMPANY_FAILURE:
    case REGISTER_FREELANCE_FAILURE:
    case RESET_PASSWORD_FAILURE:
    case UPDATE_PASSWORD_FAILURE:
    case SAVE_TALENT_FAILURE:
    case UNSAVE_TALENT_FAILURE:
    case PUBLISH_POSITION_FAILURE:
    case ACCEPT_USER_FAILURE:
    case REJECT_USER_FAILURE:
    case ADD_ROLE_FAILURE:
    case REORDER_PICTURES_FAILURE:
    case GET_SHORTLIST_FAILURE:
    case CREATE_SHORTLIST_FAILURE:
    case ADD_TALENT_SHORTLIST_FAILURE:
    case SEND_REQUESTS_FAILURE:
      return {
        show: true,
        message: payload.user_message, // @NOTE: Change to error_description to get debug info
      };

    case UPLOAD_IMAGE_FAILURE:
      return {
        show: true,
        message: payload.message,
      };

    case G_AUTH_FAILURE:
      return {
        show: true,
        message: payload.details || payload.message || payload.error,
      };

    case HIDE_ERROR:
      return initialState;

    default:
      return state;
  }
}
